export const FilterType = {
    TEXT: 'text',
    NUMBER: 'number',
    SELECT: 'select',
    SINGLE_SELECT: 'singleSelect',
    DATE: 'date',
    NUMBER_RANGE: 'numberRange',
    SLIDER_RANGE: 'sliderRange',
    OWNER: 'owner'
}